import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { FormattedHTMLMessage } from 'react-intl'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

export default ({ isOpen, toggle, error, platform }) => {
  // Generate a unique ID for the modal to connect aria attributes
  const modalId = `platform-error-modal-${platform}`
  const titleId = `platform-error-title-${platform}`

  // Determine the title message ID based on platform
  const getTitleMessageId = () => {
    switch (platform) {
      case 'uplay':
        return 'error.uplay.title'
      case 'steam':
        return 'error.steam.title'
      case 'epic':
        return 'error.epic.title'
      case 'rc':
        return 'error.robotcache.title'
      default:
        return 'error.global.title'
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      id={modalId}
      aria-labelledby={titleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={titleId} className="text-center">
          <FormattedMessage id={getTitleMessageId()} />
        </h2>

        {error && (
          <p>
            <FormattedHTMLMessage id={error} />
          </p>
        )}

        <p>
          <FormattedMessage id="error.global.footerText" />
        </p>

        <p>
          <a href="/support" aria-label="Contact support for assistance">
            <FormattedHTMLMessage id="error.global.footerLink" />
          </a>
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button block outline color="danger" onClick={toggle} aria-label="Close this message">
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}
